import { ReactNode } from 'react';

interface NavbarCollapseProps {
  children: ReactNode;
  open?: boolean;
}

const NavbarCollapse = ({ children, open = false }: NavbarCollapseProps) => {
  const isOpen = open ? 'open' : '';

  return (
    <div className={`navbar-collapse offcanvas-collapse ${isOpen}`} id="offcanvas">
      {children}
    </div>
  );
};

export default NavbarCollapse;
